import React from 'react'

import { Text } from '@domain-group/suit-theme'

interface ParagraphProps {
  boxProps?: object,
  children: React.ReactNode,
}

const Paragraph = (props: ParagraphProps) => {
  const { boxProps, children } = props

  return (
    <Text
      color="bodyFontLightColor"
      fontSize="xsmall"
      lineHeight="1.3"
      marginTop="small"
      {...boxProps}
    >
      {children}
    </Text>
  )
}

export default Paragraph
